<template>
  <div class="modal fade in modal-open" @click.self.stop="closeModal" v-if="isModalOpen">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal__header modal__header--rm-bg" :class="headerClass">
          <div class="modal__header--angles">
            <img class="modal__profile-pic" :src="rm.headshot">
            <div class="modal__contact-name">{{ rm.fullName }}</div>
            <div class="modal__contact-position">{{ rm.position }}</div>

            <div class="modal__contact-row">
              <div class="modal__contact-phone">{{ rm.phone }}</div>
              <div class="modal__contact-separator">|</div>
              <div class="modal__contact-email">{{ rm.email }}</div>
            </div>
            <div class="modal__close-btn">
              <i class="fa fa-times" @click.self.stop="closeModal"></i>
            </div>
          </div>
        </div>
        <div class="modal__body">
          <div class="container-fluid" slot="modal-body">
            <div class="modal__contact-row modal__contact-row--doc">
              <h3 class="modal__contact-msg-box--title">{{ modalData.title }}</h3>
            </div>
            <div class="modal__form-placeholder" v-if="fuelEmployee" @click="closeModal">Only members can send messages to RMs.</div>
            <form name="getCourseInfo" id="getCourseInfo" v-else>
              <div class="modal__contact-row">
                <div class="col-sm-12">
                  <textarea
                      class="modal__comment-block modal__comment-block--vendor"
                      name="message"
                      placeholder="Enter message"
                      v-model="text"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal__footer">
          <div class="modal__sending-overlay" v-if="isSending">
            <moon-loader size="25px" color="#1176BB"></moon-loader>
          </div>
          <div class="modal__send-btn" @click="sendMessage()" v-else>Send</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import MoonLoader from 'vue-spinner/dist/vue-spinner.min';

  export default {
    name: 'CourseModal',
    components: {
      MoonLoader,
    },
    data() {
      return {
        text: '',
      };
    },
    props: {
      modalKey: '',
      headerClass: '',
    },
    mounted() {
      const component = this;
      this.handler = function (e) {
        if (e.code === 'Escape') {
          component.closeModal();
        }
      }
      window.addEventListener('keyup', this.handler);
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.handler);
    },
    computed: {
      ...mapGetters('main', ['displayedModal', 'modalData', 'loaders', 'rm', 'fuelEmployee']),
      isModalOpen() {
        return this.displayedModal === this.modalKey;
      },
      headerClasses() {
        return `modal__header--${this.headerClass}`;
      },
      isSending() {
        return this.loaders.sendingMessage;
      },
      document() {
        return this.modalData;
      },
    },
    methods: {
      /**
       *  Sends message from member to the back-end server.
       */
      async sendMessage() {
        this.$store.dispatch('main/sendMessage', {
          message: `Professional Development - ${this.course.title}: ${this.text}`,
          email: this.rm.email,
          messageType: 'Professional Development Inquiry',
        });
      },
      downloadOverview() {
        if (this.content.overviewURL != "") {
          window.location = this.decode(this.vendor.overviewURL);
        }
      },
      closeModal() {
        this.$store.dispatch('main/showModal', null);
      },
    },
  };
</script>
